import { observer } from "mobx-react";
import { useStores } from "hooks/useStores";
import {FormattedMessage} from "react-intl";
import Panel, { Variant } from "../../Panel";
import {Uppercase} from "../../../styles/components";
import {Button} from "../../Button";
import * as S from './styles'

export const FAQ = observer(() => {

  const { businessStore } = useStores()

  return (
    <S.Container>
      <S.Title><FormattedMessage id="faqTitle"/></S.Title>
      <S.SubText>
          <FormattedMessage id="faqSubText"/>
      </S.SubText>

      <Panel variant={Variant.Business}>
          <Panel.Header><FormattedMessage id="faqPanel1Title"/></Panel.Header>
          <Panel.Body>
              <FormattedMessage id="faqPanel1Text"/>
          </Panel.Body>
      </Panel>

      <Panel variant={Variant.Business}>
          <Panel.Header><FormattedMessage id="faqPanel2Title"/></Panel.Header>
          <Panel.Body>
              <FormattedMessage id="faqPanel2Text"/>
          </Panel.Body>
      </Panel>

      <Panel variant={Variant.Business}>
          <Panel.Header><FormattedMessage id="faqPanel3Title"/></Panel.Header>
          <Panel.Body>
              <FormattedMessage id="faqPanel3Text"/>
          </Panel.Body>
      </Panel>

      <Panel variant={Variant.Business}>
          <Panel.Header><FormattedMessage id="faqPanel4Title"/></Panel.Header>
          <Panel.Body>
              <FormattedMessage id="faqPanel4Text"/>
          </Panel.Body>
      </Panel>

      <Panel variant={Variant.Business}>
          <Panel.Header><FormattedMessage id="faqPanel5Title"/></Panel.Header>
          <Panel.Body>
              <FormattedMessage id="faqPanel5Text"/>
          </Panel.Body>
      </Panel>

      <S.SupportBlock>
          <div>
            <S.ImageBlock/>
          </div>
          <div>
              <S.SupportTitle><FormattedMessage id="faqSupportTitle"/></S.SupportTitle>
              <S.SupportText>
                  <FormattedMessage id="faqSupportText1"/>
              </S.SupportText>
              <Button variant={Variant.Business} onClick={businessStore.toggleFeedback}>
                  <Uppercase><FormattedMessage id="faqSupportButton1"/></Uppercase>
              </Button>
          </div>
      </S.SupportBlock>
    </S.Container>
  ) 
})